import { format } from 'date-fns'
import { isEmpty } from 'ramda'
import { Fragment } from 'react'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { useDateFnsLocale } from '@/scopes/common/hooks/useDateFnsLocale'
import SectionTitle from '../SectionTitle'
import { useDestinationTitleValues } from '../useDestinationTitleValues'
import styles from './WeatherTable.module.css'

export default function WeatherTable() {
  const intl = useIntl()
  const weather = useCMSPageField('DestinationPage.weather')
  const dateFnsLocale = useDateFnsLocale()
  const destinationTitleValues = useDestinationTitleValues({ shouldUseSpecialPreposition: true })

  return (
    !isEmpty(weather) && (
      <section>
        <SectionTitle>
          {intl.formatMessage({ id: 'destination_weather_title' }, destinationTitleValues)}
        </SectionTitle>
        <div className={styles.grid}>
          <span className={styles.legend}>{intl.formatMessage({ id: 'destination_weather_max' })}</span>
          <span className={styles.legend}>{intl.formatMessage({ id: 'destination_weather_min' })}</span>
          {weather?.map((data, idx) => {
            const date = new Date(2026, idx, 1)
            const monthLongName = format(date, 'MMMM', { locale: dateFnsLocale })
            const monthShortName = format(date, 'MMM', { locale: dateFnsLocale }).replace('.', '')

            return (
              <Fragment key={monthShortName}>
                <div className={styles.month} role="group" aria-label={monthLongName}>
                  <span aria-hidden="true" className={styles.monthNameLong}>{monthLongName}</span>
                  <span aria-hidden="true" className={styles.monthNameShort}>{monthShortName}</span>
                </div>
                <span className={styles.value}>{data.max != null ? intl.formatMessage({ id: 'destination_weather_temperature' }, { temperature: data.max }) : '-'}</span>
                <span className={styles.value}>{data.min != null ? intl.formatMessage({ id: 'destination_weather_temperature' }, { temperature: data.min }) : '-'}</span>
              </Fragment>
            )
          })}
        </div>
      </section>
    )
  )
}
